export default "__VITE_ASSET__CNyj8MJ3__"